import { useModal } from '../../../../../hooks/useModal';
import { isArray, isFunction, isNumber } from 'lodash';
import store from '../../../../../redux/store';

export const useCallModal = ({ modalData }) => {
  const { id, addModal, closeModal } = useModal();

  return {
    callModal() {
      if (modalData) {
        const { action, data } = modalData;

        const callbacks = {
          open({ type, props = {}, createProps }) {
            const totalProps = { ...props, ...(isFunction(createProps) && createProps(store.getState())) };
            addModal({ type, props: totalProps });
          },
          close({ type }) {
            closeModal(type === 'current' && isNumber(id) ? id : type);
          },
        };

        isArray(action) ? action.forEach((act) => callbacks[act]?.(data[act])) : callbacks[action]?.(data);
      }
    },
  };
};
